module.exports = __webpack_public_path__ + "static/assets/7377412a657d6b3f173bbb9ebf5871e2.png";